export default __webpack_public_path__ + "img/check.5b24dfae7f957263d46c65db1b1f61a5.svg";